import getStore from '../store/store';
import { getUserMailboxInfo } from 'owa-client-ids';
import { CalendarCacheInitializationLoadState } from '../store/schema/CalendarCacheInitializationState';

export function getCacheLoadState(mailboxId?: string): CalendarCacheInitializationLoadState {
    if (!mailboxId) {
        // get default account's mailboxId
        mailboxId = getUserMailboxInfo().mailboxId;
    }
    let loadState: CalendarCacheInitializationLoadState = getStore().calendarCacheInitializationState.calendarCacheInitializationLoadState.get(
        mailboxId
    );

    if (loadState == undefined) {
        loadState = CalendarCacheInitializationLoadState.NotLoaded;
    }

    return loadState;
}
export function getLoadingScenarios() {
    return getStore().calendarCacheInitializationState.calendarCacheInitializationLoadingScenarios;
}
